import queryString from 'query-string';

// fulfilled by react-router-redux's routerReducer
const getRouter = state => state.router;
// this returns path without the domain without the query
export const getPathName = state => getRouter(state).location.pathname;
// this returns the query portion of the url, includes leading '?'
export const getSearch = state => getRouter(state).location.search;
export const getFullPath = state => { return getPathName(state) + getSearch(state); };

/**
 * Retrieve all the router query params as an Object
 * @param {Object} state The redux state
 * @returns {Object} Object with query params as kvps
 */
export const getAllQueryParams = (state) => {
  const query = getSearch(state);
  if (!query) {
    return {};
  }

  const result = queryString.parse(query);
  return result;
};

/**
 * Retrieve a single param value from the router query
 * @param {*} state The redux state
 * @param {*} param The param to get
 * @returns {string} The param value if found else null
 */
export const getQueryParam = (state, param) => {
  const allQueryParams = getAllQueryParams(state);

  if (param in allQueryParams) {
    return allQueryParams[param];
  } else {
    return null;
  }
};

/**
 * Retrieve all the current query params divided by the given concerningParams
 * @param {Object} state The redux state
 * @param {Array} concerningParams Array of params to sort out
 * @returns {Object} Sorted into 'concerning' and 'other' attributes
 */
export const sortQueryParamsByConcerning = (state, concerningParams) => {
  const result = {
    concerning: {},
    other: {}
  };
  const allQueryParams = getAllQueryParams(state);
  for (const queryParam of Object.keys(allQueryParams)) {
    if (concerningParams.includes(queryParam)) {
      result.concerning[queryParam] = allQueryParams[queryParam];
    } else {
      result.other[queryParam] = allQueryParams[queryParam];
    }
  }
  return result;
};


// WEBPACK FOOTER //
// src/reducers/routerExtra.js